export function getEtapa(etapa) {
  switch (etapa) {
    case "juicio":
      return "JUICIO CONTENCISO ADMINISTRATIVO";
    case "fiscalizacion":
      return "PROCEDIMIENTO DE FISCALIZACIÓN";
    case "recurso":
      return "RECURSO ADMINISTRATIVO";
    case "contract":
      return "CONTRATO DE PRESTACIÓN DE SERVICIOS";
    case "cotizacion":
      return "COTIZACIÓN";
    case "minutas":
      return "MINUTAS";
    case "fc":
      return "FICHA TÉCNICA";
    default:
      return "Etapa desconocida";
  }
}